import Swiper from 'swiper/bundle';
import videojs from 'video.js';

class SwiperHero {
    constructor() {
        if (SwiperHero.instance) {
            return SwiperHero.instance;
        }
        SwiperHero.instance = this;

        this.players = [];
        this.initSwiperHero();
    }

    initSwiperHero() {
        console.log("Initializing SwiperHero...");

        // Initialize Swiper
        this.swiperHero = new Swiper(".swiper-hero", {
            grabCursor: true,
            effect: "creative",
            creativeEffect: {
                prev: {
                    shadow: true,
                    translate: ["-20%", 0, -1],
                },
                next: {
                    translate: ["100%", 0, 0],
                },
            },
            navigation: {
                nextEl: ".block-hero .swiper-next",
                prevEl: ".block-hero .swiper-prev",
            },
            on: {
                init: () => {
                    console.log("Swiper initialized...");
                    this.handleInit();
                },
                slideChange: () => {
                    console.log("Slide changed...");
                    this.handleSlideChange();
                }
            }
        });

        // Initialize Video.js players for each video in the swiper
        document.querySelectorAll('.swiper-hero .video-js').forEach(videoElement => {
            const player = videojs(videoElement, {
                controls: false,
                autoplay: false,
                preload: 'auto',
                fluid: true,
                muted: true
            });

            player.on('ended', () => {
                if (videoElement.hasAttribute('loop')) {
                    player.currentTime(0);
                    player.play();
                }
            });

            player.on('loadeddata', () => {
                console.log("Video data loaded for:", videoElement);
            });

            player.on('canplay', () => {
                console.log("Video can play for:", videoElement);
            });

            player.on('play', () => {
                console.log("Video play event for:", videoElement);
            });

            player.on('playing', () => {
                console.log("Video playing event for:", videoElement);
            });

            player.on('pause', () => {
                console.log("Video pause event for:", videoElement);
            });

            videoElement.player = player; // Store the player instance in the element
            this.players.push({ player, element: videoElement });
            console.log("Video.js player initialized for:", videoElement);
        });

        this.handleInit();
    }

    handleInit() {
        console.log("Handling init...");
        this.handleSlideChange(true); // Ensure we handle the initial slide change properly

        // Add event listeners for user interaction to try to play videos on mobile devices
        this.addMobileInteractionListeners();
    }

    addMobileInteractionListeners() {
        const interactionEvents = ['touchstart', 'click'];
        interactionEvents.forEach(event => {
            document.addEventListener(event, this.handleUserInteraction.bind(this), { once: true });
        });
    }

    handleUserInteraction() {
        console.log("User interaction detected, trying to play videos...");
        this.players.forEach(({ player, element }, index) => {
            const slide = element.closest('.swiper-slide');
            const isActive = slide && slide.classList.contains('swiper-slide-visible');
            if (isActive) {
                console.log(`Playing video in slide ${index} after user interaction`);
                player.play().catch(error => {
                    console.error('Error playing video after user interaction:', error);
                });
            }
        });
    }

    handleSlideChange(isInit = false) {
        console.log("Handling slide change...", { isInit });
        if (!this.swiperHero) return;

        const activeIndex = this.swiperHero.activeIndex;
        console.log("Active index:", activeIndex);

        this.players.forEach(({ player, element }, index) => {
            const slide = element.closest('.swiper-slide');
            const isActive = index === activeIndex;
            const isFirstSlideInit = isInit && index === activeIndex;

            console.log(`Slide ${index}:`, { isActive, isFirstSlideInit });

            if (isActive || isFirstSlideInit) {
                console.log(`Playing video in slide ${index}`);
                console.log(`Player ready state: ${player.readyState()}`);

                if (player.readyState() >= 3) { // Check if the video is ready to play
                    player.play().catch(error => {
                        console.error('Error playing video:', error);
                    });
                } else {
                    player.one('canplay', () => {
                        console.log(`Playing video in slide ${index} after canplay event`);
                        player.play().catch(error => {
                            console.error('Error playing video:', error);
                        });
                    });

                    // Check again after a small delay if the video is still not ready
                    setTimeout(() => {
                        if (player.readyState() >= 3) {
                            player.play().catch(error => {
                                console.error('Error playing video:', error);
                            });
                        }
                    }, 800); // 1-second delay
                }
            } else {
                console.log(`Pausing video in slide ${index}`);
                player.pause();
            }
        });
    }
}

// Export the class for use in other modules
export default SwiperHero;
